var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "button-component",
        { active: _vm.active, "px-3": !_vm.small, "px-2": _vm.small },
      ],
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }